export enum EBitfPQueryComparators {
  EQUAL,
  GREATER,
  LOWER,
  CONTAINS,
}
